{
  "fr": {
    "phase": {
      "attributes": {
        "end_date": "Date d'achèvement",
        "internal_note": "Note interne",
        "name": "Nom",
        "start_date": "Date de début"
      },
      "labels": {
        "phase": "Pas de phase | Une phase | {count} Phases"
      },
      "toasts": {
        "create": "Phase créée",
        "delete": "Phase supprimée",
        "update": "Phase modifiée"
      },
      "validation": {
        "needName": "Titre requis",
        "needNumber": "Doit être un nombre (par exemple 85.5)"
      }
    }
  }
}